/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from "react";
import { useHistory } from "react-router";
import { getLanguage, onAxiosApiCall } from "../../../../utils";
import { API_URL } from "../../../../constants";

export default function VerifyEmail(props) {
  const history = useHistory();
  useEffect(() => {
    var language = getLanguage(navigator.language);

    onAxiosApiCall(API_URL + language + "/verify-email", "POST", {code: props.match.params.code}).then((response) => {
      history.replace("/login", {verifyEmail: response})
    })
    .catch((error) => {
      console.log("error", error);
    });
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-root">
      <div id="splash-screen" className="kt-splash-screen">
      <img
        src="/media/logos/logoyoushowazul.png"
        alt="Youshow logo"
      />
      <svg className="splash-spinner" viewBox="0 0 50 50">
        <circle className="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="5"
        ></circle>
      </svg>
    </div>
      </div>
       
    </>
  );
}
